import * as Yup from 'yup';

const simpleOrderItemSchema = {
	name: Yup.string().required('يجب ادخال اسم المنتج '),
	price: Yup.number().typeError('ادخل رقم صحيح').min(0, 'يجب ادخال السعر'),
};

export const simpleItemsSchema = Yup.array().of(
	Yup.object().shape({
		...simpleOrderItemSchema,
	}),
);
